export default __webpack_public_path__ + "loader.9a63e879.gif";